import { createSlice } from "@reduxjs/toolkit";
import { nextStepAPI } from "../../../services/guestUsers/guestUserAllAPIService";
const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const stepperNextStepSlice = createSlice({
  name: "stepperNextStep",
  initialState: data,
  reducers: {
    stepperNextStepSliceInfo(state) {
      state.isLoading = true;
    },
    stepperNextStepSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    stepperNextStepSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    stepperNextStepSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const stepperNextStepHandler = (data) => async (dispatch) => {
  try {
    dispatch(stepperNextStepSliceAction.stepperNextStepSliceInfo());
    const response = await nextStepAPI(data);
    dispatch(stepperNextStepSliceAction.stepperNextStepSliceSuccess(response));
  } catch (e) {
    dispatch(stepperNextStepSliceAction.stepperNextStepSliceFailure(e));
  }
};
export default stepperNextStepSlice.reducer;
export const stepperNextStepSliceAction = stepperNextStepSlice.actions;
